@if (state$ | async; as state) {
  <div class="page-header">
    <div class="page-title">Użytkownicy</div>

    <div class="header-toolbar">
      @if (!state.inviteOpen) {
        <button class="btn" type="button" (click)="openInvite()">+ Zaproś użytkownika</button>
      }
    </div>
  </div>

  <!-- Inline, above the table: the app has no modal and this spec does not introduce one -->
  @if (state.inviteOpen) {
    <form class="invite-form" (submit)="onInviteSubmit($event, nameInput.value, emailInput.value, roleSelect.value, adminCheck.checked)">
      <div class="invite-fields">
        <label class="field">
          <span class="field-label">Imię i nazwisko</span>
          <input #nameInput class="field-input" type="text">
        </label>

        <label class="field">
          <span class="field-label">E-mail</span>
          <input #emailInput class="field-input" type="text" spellcheck="false" autocomplete="off">
        </label>

        <label class="field">
          <span class="field-label">Rola</span>
          <select #roleSelect class="field-input">
            <option value="Planner">Planista</option>
            <option value="Foreman">Brygadzista</option>
          </select>
        </label>

        <label class="admin-check">
          <input #adminCheck type="checkbox">
          Administrator
        </label>
      </div>

      <div class="invite-actions">
        <button class="btn" type="submit" [disabled]="state.inviting">{{ state.inviting ? 'Zapraszanie…' : 'Zaproś' }}</button>
        <button class="btn" type="button" (click)="closeInvite()">Anuluj</button>

        @if (state.inviteError) {
          <span class="form-error">{{ state.inviteError }}</span>
        }
      </div>
    </form>
  }

  <!-- The one-time link, visible exactly until the panel is closed -->
  @if (state.link; as link) {
    <div class="link-panel">
      <div class="link-panel-title">Link do ustawienia hasła — {{ link.displayName }}</div>

      <div class="link-panel-row">
        <input #linkInput class="field-input link-input text-mono" type="text" readonly [value]="link.linkUrl" (focus)="linkInput.select()">
        <button class="btn" type="button" (click)="copyLink(link.linkUrl)">{{ linkCopied() ? 'Skopiowano' : 'Kopiuj link' }}</button>
        <button class="btn" type="button" (click)="closeLink()">Zamknij</button>
      </div>

      <div class="link-panel-hint">{{ linkValidity(link.purpose) }} Przekaż go tej osobie — po zamknięciu nie będzie go już widać.</div>
    </div>
  }

  @if (state.actionError) {
    <div class="action-error">{{ state.actionError }}</div>
  }

  <!-- the count line and the table with its header row are the layout; the rows and the count are
       the data, drawn as shadows until it lands (0128); the hint is text in both branches -->
  <div class="list-count">
    @if (state.loading) {
      <span class="shadow"></span>
    } @else if (state.members) {
      {{ state.members.length }} os.
    }
    <span class="list-hint">· prawy klik na wierszu otwiera akcje, dwuklik na nazwie ją edytuje</span>
  </div>

  <div class="list-table">
    <div class="list-row list-row-header member-row">
      <div class="list-cell">Imię i nazwisko</div>
      <div class="list-cell">E-mail</div>
      <div class="list-cell">Rola</div>
      <div class="list-cell member-row-admin">Administrator</div>
      <div class="list-cell">Status</div>
      <div class="list-cell">Ostatnie logowanie</div>
    </div>

    @if (state.loading) {
      <!-- five rows of the page's own row: the name cell's line-height holds it at the row's height; a check mark
           is a mark and most rows have none, so Administrator stays empty (0128) -->
      @for (row of shadowRows; track row) {
        <div class="list-row list-row-shadow member-row">
          <div class="list-cell member-row-name"><span class="shadow shadow-long"></span></div>
          <div class="list-cell"><span class="shadow"></span></div>
          <div class="list-cell"><span class="shadow shadow-short"></span></div>
          <div class="list-cell member-row-admin"></div>
          <div class="list-cell"><span class="shadow shadow-short"></span></div>
          <div class="list-cell"><span class="shadow shadow-short"></span></div>
        </div>
      }
    } @else if (state.members) {
      @for (member of state.members; track member.id) {
        <div class="list-row member-row" [class.deactivated]="member.status === 'Deactivated'" (contextmenu)="onRowContextMenu($event, member)">
          <div class="list-cell member-row-name" [title]="member.displayName" (dblclick)="startEditing(member)">
            @if (editingMemberId() === member.id) {
              <input #editInput class="field-input" [value]="member.displayName"
                (keyup.enter)="saveName(member, editInput.value)" (keyup.escape)="stopEditing()" (blur)="stopEditing()">
            } @else {
              {{ member.displayName }}
              @if (member.isYou) {
                <span class="member-row-you">(Ty)</span>
              }
            }
          </div>
          <div class="list-cell member-row-email" [title]="member.email">{{ member.email }}</div>
          <div class="list-cell member-row-role">{{ member.roleLabel }}</div>
          <div class="list-cell member-row-admin">{{ member.isAdmin ? '✓' : '' }}</div>
          <div class="list-cell member-row-status">
            {{ member.statusLabel }}
            @if (member.lockedUntil) {
              <span class="member-row-locked">Zablokowany do {{ member.lockedUntil | date:'HH:mm' }}</span>
            }
          </div>
          <div class="list-cell member-row-sign-in text-mono">{{ member.lastSignInAt ? (member.lastSignInAt | date:'HH:mm dd.MM.yyyy') : '—' }}</div>
        </div>
      }
    }
  </div>

  @if (state.rowMenu) {
    <context-menu [items]="rowMenuItems(state)" [openAt]="state.rowMenu.position"
      (actionSelected)="onRowMenuAction($event)" (closed)="onRowMenuClose()"></context-menu>
  }
}
